import React, { useState } from "react";
import floria_heights_cover from "../images/projects/floria_heights_cover.jpg";
import {
  Building2,
  MapPin,
  Trees,
  Waves,
  Dumbbell,
  ShieldCheck,
  Sparkles,
  ChevronRight,
  Home,
  Plane,
  School,
  Landmark,
  Mountain,
  X,
  Clock,
  Ruler,
  CreditCard,
  Users,
  Award,
  Wind,
  Sun,
  Lock,
  Wifi,
  Droplets,
  Coffee,
  BookOpen,
  Zap,
} from "lucide-react";
import { Helmet } from "react-helmet";

export default function FloriaHeightsPage() {
  const [showPaymentPlan, setShowPaymentPlan] = useState(false);

  const whatsappLink =
    "https://wa.me/923487172565?text=Hi%20I%20want%20to%20book%20a%20unit%20at%20Floria%20Heights";

  const amenities = [
    "Smart Home System",
    "Shared Laundry",
    "Guest Rooms",
    "Fire Extinguishing System",
    "Power Backup",
    "Gymnasium",
    "Car Wash",
    "Prayer Area",
    "Coffee Shop",
    "Kids Play Area",
    "Elevator",
    "Extra Visitors Parking",
    "Library",
    "Walking Track",
    "Swimming Pool",
    "Wide Corridors",
    "Day Care",
    "Sky Garden",
    "EV Recharge Station",
    "Turkish Hamam",
    "Tennis Court",
    "CCTV Surveillance",
    "Multi Purpose Hall",
    "Floria Service Apartments",
  ];

  const apartmentPlans = [
    {
      code: "A-01",
      type: "2 Bed Apartment",
      area: "1731 Sqft",
      detail: "3 Sided Corner",
      image:
        "https://images.unsplash.com/photo-1507089947368-19c1da9775ae?q=80&w=1974&auto=format",
    },
    {
      code: "A-02",
      type: "3 Bed Apartment",
      area: "2319 Sqft",
      detail: "3 Sided Corner",
      image:
        "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?q=80&w=2070&auto=format",
    },
    {
      code: "A-03",
      type: "1 Bed Apartment",
      area: "867 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2070&auto=format",
    },
    {
      code: "A-04",
      type: "1 Bed Apartment",
      area: "802 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1560185893-a55cbc8c57e8?q=80&w=2070&auto=format",
    },
    {
      code: "A-05",
      type: "1 Bed Apartment",
      area: "864 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?q=80&w=2070&auto=format",
    },
    {
      code: "A-06",
      type: "2 Bed Apartment",
      area: "1341 Sqft",
      detail: "2 Sided Corner",
      image:
        "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=1974&auto=format",
    },
    {
      code: "A-07",
      type: "2 Bed Apartment",
      area: "1793 Sqft",
      detail: "3 Sided Corner",
      image:
        "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format",
    },
    {
      code: "A-08",
      type: "3 Bed Apartment",
      area: "2259 Sqft",
      detail: "2 Sided Corner",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format",
    },
    {
      code: "A-09",
      type: "1 Bed Apartment",
      area: "806 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1560448204-603b3fc33ddc?q=80&w=2070&auto=format",
    },
    {
      code: "A-10 & A-11",
      type: "1 Bed Apartment",
      area: "781 Sqft",
      detail: "Modern Layout",
      image:
        "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?q=80&w=2070&auto=format",
    },
    {
      code: "A-12",
      type: "2 Bed Apartment",
      area: "1310 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1515263487990-61b07816b324?q=80&w=2070&auto=format",
    },
    {
      code: "Studio",
      type: "Studio Apartment",
      area: "500 Sqft",
      detail: "Compact Luxury",
      image:
        "https://images.unsplash.com/photo-1536376072261-38c75010e6c9?q=80&w=1974&auto=format",
    },
    {
      code: "C-01 | C-02",
      type: "1 Bed Apartment",
      area: "914 Sqft",
      detail: "Corner",
      image:
        "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?q=80&w=2070&auto=format",
    },
    {
      code: "C-03 | C-04",
      type: "1 Bed Apartment",
      area: "674 Sqft",
      detail: "Elegant Layout",
      image:
        "https://images.unsplash.com/photo-1560185127-6ed189bf02f4?q=80&w=2070&auto=format",
    },
    {
      code: "C-03a | C-04a",
      type: "Studio Apartment",
      area: "448 Sqft",
      detail: "Minimal Luxury",
      image:
        "https://images.unsplash.com/photo-1536376072261-38c75010e6c9?q=80&w=1974&auto=format",
    },
  ];

  const connectivity = [
    [
      "Faisal Hills ARC",
      "100 Steps",
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1973&auto=format",
    ],
    [
      "Roots School",
      "02 Mins",
      "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format",
    ],
    [
      "Margalla Avenue",
      "05 Mins",
      "https://images.unsplash.com/photo-1460317442991-0ec209397118?q=80&w=2070&auto=format",
    ],
    [
      "M-1 & M-2 Motorway",
      "05 Mins",
      "https://images.unsplash.com/photo-1582487928893-70747736b97f?q=80&w=2070&auto=format",
    ],
    [
      "CPEC Route Access",
      "06 Mins",
      "https://images.unsplash.com/photo-1542224566-6e3c2c2ed90c?q=80&w=2069&auto=format",
    ],
    [
      "Gandhara Museum",
      "08 Mins",
      "https://images.unsplash.com/photo-1566288623394-377af472d81b?q=80&w=2070&auto=format",
    ],
    [
      "UET Taxila",
      "10 Mins",
      "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=2070&auto=format",
    ],
    [
      "F-10 Markaz",
      "20 Mins",
      "https://images.unsplash.com/photo-1519699047748-de8e457a634e?q=80&w=2070&auto=format",
    ],
    [
      "Fatima Jinnah Park",
      "20 Mins",
      "https://images.unsplash.com/photo-1475938476803-32a7e851dab6?q=80&w=2072&auto=format",
    ],
    [
      "Islamabad Airport",
      "20 Mins",
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?q=80&w=2074&auto=format",
    ],
    [
      "Faisal Masjid",
      "25 Mins",
      "https://images.unsplash.com/photo-1584551246679-258d64b32229?q=80&w=1974&auto=format",
    ],
  ];

  const directors = [
    {
      name: "Naveed Akhtar Satti",
      role: "Director Sales & Finance",
      image:
        "https://ui-avatars.com/api/?name=Naveed+Akhtar+Satti&background=4F46E5&color=fff",
    },
    {
      name: "Muhammad Ayub Awan",
      role: "Project Director",
      image:
        "https://ui-avatars.com/api/?name=Muhammad+Ayub+Awan&background=10B981&color=fff",
    },
    {
      name: "Irfan Mughal",
      role: "Director Marketing (Overseas)",
      image:
        "https://ui-avatars.com/api/?name=Irfan+Mughal&background=F59E0B&color=fff",
    },
    {
      name: "Muhammad Rehan Omer",
      role: "Director Sales & Operations",
      image:
        "https://ui-avatars.com/api/?name=Muhammad+Rehan+Omer&background=EF4444&color=fff",
    },
  ];

  const paymentPlan = {
    studio: [
      {
        type: "Studio",
        size: "424",
        booking: "1,399,000",
        confirmation: "257,700",
        allocation: "700,700",
        total: "6,996,000",
      },
      {
        type: "Studio",
        size: "500",
        booking: "1,650,000",
        confirmation: "304,000",
        allocation: "825,000",
        total: "8,250,000",
      },
    ],

    oneBed: [
      {
        type: "1 Bed",
        size: "781",
        booking: "2,577,000",
        confirmation: "474,500",
        allocation: "1,294,000",
        total: "12,886,500",
      },
      {
        type: "1 Bed",
        size: "810",
        booking: "2,673,000",
        confirmation: "492,500",
        allocation: "1,336,500",
        total: "13,365,000",
      },
      {
        type: "1 Bed",
        size: "841",
        booking: "2,775,300",
        confirmation: "511,239",
        allocation: "1,387,650",
        total: "13,876,500",
      },
      {
        type: "1 Bed",
        size: "802",
        booking: "2,646,500",
        confirmation: "487,500",
        allocation: "1,324,000",
        total: "13,233,000",
      },
      {
        type: "1 Bed",
        size: "806",
        booking: "2,660,000",
        confirmation: "489,000",
        allocation: "1,348,000",
        total: "13,299,000",
      },
      {
        type: "1 Bed",
        size: "864",
        booking: "2,851,000",
        confirmation: "525,000",
        allocation: "1,430,000",
        total: "14,256,000",
      },
      {
        type: "1 Bed",
        size: "867",
        booking: "2,861,000",
        confirmation: "525,000",
        allocation: "1,469,500",
        total: "14,305,500",
      },
    ],

    twoBed: [
      {
        type: "2 Bed",
        size: "1310",
        booking: "4,323,000",
        confirmation: "796,000",
        allocation: "2,204,000",
        total: "21,615,000",
      },
      {
        type: "2 Bed",
        size: "1341",
        booking: "4,425,000",
        confirmation: "815,000",
        allocation: "2,216,500",
        total: "22,126,500",
      },
      {
        type: "2 Bed",
        size: "1731",
        booking: "5,712,500",
        confirmation: "1,052,000",
        allocation: "2,861,500",
        total: "28,561,500",
      },
      {
        type: "2 Bed",
        size: "1794",
        booking: "5,920,000",
        confirmation: "1,090,500",
        allocation: "2,961,500",
        total: "29,601,000",
      },
    ],

    threeBed: [
      {
        type: "3 Bed",
        size: "2259",
        booking: "7,454,500",
        confirmation: "1,373,000",
        allocation: "3,732,700",
        total: "37,273,500",
      },
      {
        type: "3 Bed",
        size: "2319",
        booking: "7,652,500",
        confirmation: "1,409,000",
        allocation: "3,840,000",
        total: "38,263,500",
      },
    ],
  };

  return (
    <div className="bg-gradient-to-br from-[#0a0608] via-[#14080e] to-[#0a0608] text-white overflow-hidden">
      <Helmet>
        <title>Floria Heights | EstateGhar</title>
        <meta
          name="description"
          content="Floria Heights - Luxury Residential Development in Islamabad"
        />
        <meta
          name="keywords"
          content="floria heights, luxury residential, projects in islamabad, real estate, property requests, buy property, rent property, real estate agents, property listings, EstateGhar"
        />
      </Helmet>
      {/* HERO */}
      <section className="relative min-h-screen flex items-center">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=2070&auto=format"
            alt="Luxury apartment building"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#3d0b13]/90 via-[#2a0510]/70 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0608] via-transparent to-transparent" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 py-24 grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6 border border-[#c94463]/30">
              <Sparkles className="w-4 h-4 text-[#c94463]" />
              <span className="text-sm tracking-wide">Seven Ventures</span>
            </div>

            <h1 className="text-6xl md:text-8xl leading-none font-bold mb-8">
              FLORIA
              <span className="block font-light text-white bg-gradient-to-r  bg-clip-text text-transparent">
                HEIGHTS
              </span>
            </h1>

            <p className="text-2xl text-gray-200 mb-6 font-light">
              An Elevated Living Experience
            </p>

            <p className="text-gray-300 leading-8 max-w-xl">
              Inspired by light. Elevated by nature. A luxury residential
              apartment tower at the foot of the Margalla Hills in Faisal Hills,
              Islamabad.
            </p>

            <div className="flex flex-wrap gap-4 mt-10">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-gradient-to-r from-[#a02c46] to-[#c43a58] text-white rounded-full font-semibold hover:shadow-lg hover:shadow-[#a02c46]/30 transition-all duration-300 hover:scale-105"
              >
                Book Now
              </a>

              <button
                onClick={() => setShowPaymentPlan(true)}
                className="px-8 py-4 border border-[#c94463]/50 rounded-full bg-white/5 hover:bg-[#a02c46]/20 transition-all duration-300 backdrop-blur-sm"
              >
                View Payment Plan
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-5">
            <div className="bg-[#1c0a10]/60 backdrop-blur-sm rounded-3xl p-8 border border-[#c94463]/30 hover:border-[#c94463]/60 transition-all duration-300 transform hover:-translate-y-2">
              <Mountain className="w-10 h-10 text-[#c94463] mb-5" />
              <h3 className="text-2xl mb-3">Margalla Views</h3>
              <p className="text-gray-300">
                Timeless skyline shaped by nature.
              </p>
            </div>

            <div className="bg-[#1c0a10]/60 backdrop-blur-sm rounded-3xl p-8 mt-14 border border-[#c94463]/30 hover:border-[#c94463]/60 transition-all duration-300 transform hover:-translate-y-2">
              <Trees className="w-10 h-10 text-[#c94463] mb-5" />
              <h3 className="text-2xl mb-3">Sky Gardens</h3>
              <p className="text-gray-300">Breathing spaces above the city.</p>
            </div>

            <div className="bg-[#1c0a10]/60 backdrop-blur-sm rounded-3xl p-8 -mt-4 border border-[#c94463]/30 hover:border-[#c94463]/60 transition-all duration-300 transform hover:-translate-y-2">
              <Building2 className="w-10 h-10 text-[#c94463] mb-5" />
              <h3 className="text-2xl mb-3">Modern Towers</h3>
              <p className="text-gray-300">
                Timeless architecture and elegance.
              </p>
            </div>

            <div className="bg-[#1c0a10]/60 backdrop-blur-sm rounded-3xl p-8 mt-10 border border-[#c94463]/30 hover:border-[#c94463]/60 transition-all duration-300 transform hover:-translate-y-2">
              <Sparkles className="w-10 h-10 text-[#c94463] mb-5" />
              <h3 className="text-2xl mb-3">Luxury Living</h3>
              <p className="text-gray-300">
                Refined design meets purposeful living.
              </p>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#c94463] rounded-full flex justify-center">
            <div className="w-1 h-2 bg-[#c94463] rounded-full mt-2 animate-pulse"></div>
          </div>
        </div>
      </section>

      {/* INTRO with image */}
      <section className="py-28 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-6">
              <Award className="w-4 h-4 text-[#c94463]" />
              <span className="text-sm tracking-wide text-[#c94463]">
                A Vision Elevated
              </span>
            </div>

            <h2 className="text-5xl font-light leading-tight mb-8">
              More Than
              <span className="block font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
                A Building
              </span>
            </h2>

            <p className="text-gray-300 leading-8 mb-6">
              Floria Heights envisions refined living, captivating views, and
              purposeful design. Every corner speaks of elegance, every window
              frames nature's masterpiece.
            </p>

            <div className="flex gap-6 mt-8">
              <div className="flex items-center gap-3">
                <Sun className="w-5 h-5 text-[#c94463]" />
                <span className="text-sm">Natural Light</span>
              </div>
              <div className="flex items-center gap-3">
                <Wind className="w-5 h-5 text-[#c94463]" />
                <span className="text-sm">Fresh Air</span>
              </div>
              <div className="flex items-center gap-3">
                <Lock className="w-5 h-5 text-[#c94463]" />
                <span className="text-sm">Secure Living</span>
              </div>
            </div>

            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex mt-8 px-8 py-4 bg-gradient-to-r from-[#a02c46] to-[#c43a58] rounded-full transition-all duration-300 font-semibold hover:shadow-lg hover:scale-105"
            >
              Book Your Apartment
            </a>
          </div>

          <div className="relative group">
            <div className="absolute inset-0 bg-gradient-to-r from-[#c94463] to-[#e87a9c] rounded-[40px] blur-2xl opacity-20 group-hover:opacity-40 transition-opacity"></div>
            <img
              src={floria_heights_cover}
              alt="Floria Heights Exterior"
              className="rounded-[40px] h-[650px] w-full object-cover relative z-10 shadow-2xl border border-[#c94463]/30"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#a02c46] rounded-2xl p-4 z-20 shadow-xl">
              <Building2 className="w-8 h-8 text-white" />
            </div>
          </div>
        </div>
      </section>

      {/* DIRECTORS with images */}
      <section className="py-24 bg-gradient-to-b from-[#0e070a] to-[#14080e]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-4">
              <Users className="w-4 h-4 text-[#c94463]" />
              <span className="text-sm tracking-wide text-[#c94463]">
                Leadership
              </span>
            </div>
            <h2 className="text-5xl font-light">
              Board of{" "}
              <span className="font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
                Directors
              </span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {directors.map((director, index) => (
              <div
                key={index}
                className="group bg-gradient-to-b from-[#1c0a10] to-[#13080c] rounded-3xl p-8 border border-[#c94463]/30 hover:border-[#c94463]/70 transition-all duration-500 hover:transform hover:-translate-y-3 text-center"
              >
                <div className="relative inline-block mb-6">
                  <div className="w-28 h-28 rounded-full overflow-hidden border-4 border-[#c94463] mx-auto">
                    <img
                      src={director.image}
                      alt={director.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 bg-[#a02c46] rounded-full p-1">
                    <Award className="w-3 h-3 text-white" />
                  </div>
                </div>

                <h3 className="text-xl mb-2 font-semibold">{director.name}</h3>
                <p className="text-gray-400 text-sm">{director.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* AMENITIES with icons */}
      <section className="py-28 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-4">
            <Sparkles className="w-4 h-4 text-[#c94463]" />
            <span className="text-sm tracking-wide text-[#c94463]">
              World-Class
            </span>
          </div>
          <h2 className="text-5xl font-light">
            Elevated{" "}
            <span className="font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
              Lifestyle
            </span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
            Experience luxury at every turn with our premium amenities
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {amenities.slice(0, 24).map((amenity, index) => {
            const icons = [
              Wifi,
              Droplets,
              Wind,
              Sun,
              Zap,
              Lock,
              ShieldCheck,
              Dumbbell,
              Waves,
              Trees,
              Coffee,
              BookOpen,
            ];
            const IconComponent = icons[index % icons.length] || Sparkles;
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-[#13080c] to-[#1a0c12] border border-[#c94463]/30 rounded-2xl p-6 hover:border-[#c94463]/70 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-xl"
              >
                <div className="w-12 h-12 rounded-xl bg-[#a02c46]/20 flex items-center justify-center mb-4 group-hover:bg-[#a02c46]/40 transition">
                  <IconComponent className="w-6 h-6 text-[#c94463]" />
                </div>
                <h3 className="text-md font-medium">{amenity}</h3>
              </div>
            );
          })}
        </div>
      </section>

      {/* APARTMENTS with images */}
      <section className="py-28 px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-4">
            <Building2 className="w-4 h-4 text-[#c94463]" />
            <span className="text-sm tracking-wide text-[#c94463]">
              Residences
            </span>
          </div>
          <h2 className="text-5xl font-light">
            Apartment{" "}
            <span className="font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
              Collection
            </span>
          </h2>
          <p className="text-gray-400 mt-4">
            Discover your perfect space designed for modern luxury living
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {apartmentPlans.map((plan, index) => (
            <div
              key={index}
              className="group bg-gradient-to-b from-[#13080c] to-[#1a0c12] rounded-3xl border border-[#c94463]/30 overflow-hidden hover:border-[#c94463]/70 transition-all duration-500 hover:transform hover:-translate-y-3"
            >
              <div className="h-56 overflow-hidden relative">
                <img
                  src={plan.image}
                  alt={plan.type}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute top-4 right-4 bg-[#a02c46] rounded-full px-3 py-1 text-xs font-semibold">
                  {plan.code}
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-2xl font-light">{plan.type}</h3>
                  <ChevronRight className="w-5 h-5 text-[#c94463] group-hover:translate-x-1 transition" />
                </div>
                <p className="text-gray-400 text-sm mb-4">{plan.detail}</p>
                <div className="border-t border-[#c94463]/30 pt-4 flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <Ruler className="w-4 h-4 text-[#c94463]" />
                    <span className="text-gray-500 text-sm">Total Area</span>
                  </div>
                  <span className="text-xl font-semibold text-[#c94463]">
                    {plan.area}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* LOCATION section with images */}
      <section className="py-28 bg-gradient-to-b from-[#0e070a] to-[#14080e]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-4">
              <MapPin className="w-4 h-4 text-[#c94463]" />
              <span className="text-sm tracking-wide text-[#c94463]">
                Prime Location
              </span>
            </div>
            <h2 className="text-5xl font-light">
              A Perfect Point
              <span className="block font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
                of Balance
              </span>
            </h2>
          </div>

          <div className="grid lg:grid-cols-2 gap-12">
            <div className="space-y-4">
              {connectivity.map((item, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between bg-[#1c0a10]/50 rounded-xl px-6 py-4 border border-[#c94463]/20 hover:border-[#c94463]/50 transition-all duration-300"
                >
                  <div className="flex items-center gap-4">
                    <MapPin className="w-4 h-4 text-[#c94463]" />
                    <span className="text-gray-200">{item[0]}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Clock className="w-4 h-4 text-[#c94463]" />
                    <span className="text-[#c94463] font-medium">
                      {item[1]}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="relative rounded-3xl overflow-hidden h-[500px] group">
              <img
                src="https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?q=80&w=2070&auto=format"
                alt="Islamabad City View"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0608] via-transparent to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <div className="bg-black/60 backdrop-blur-md rounded-2xl p-4 border border-[#c94463]/30">
                  <p className="text-[#c94463] text-sm">
                    Heart of Faisal Hills
                  </p>
                  <p className="text-white text-lg">
                    Seamless access to major city arteries
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PAYMENT PLAN MODAL */}
      {showPaymentPlan && (
        <div className="fixed inset-0 z-50 bg-black/90 backdrop-blur-md flex items-center justify-center p-4 animate-in fade-in duration-300">
          <div className="bg-gradient-to-b from-[#13080c] to-[#1a0c12] border border-[#c94463]/40 rounded-3xl max-w-6xl w-full p-8 relative overflow-auto max-h-[90vh] shadow-2xl">
            <button
              onClick={() => setShowPaymentPlan(false)}
              className="absolute top-5 right-5 w-10 h-10 rounded-full bg-[#a02c46]/20 hover:bg-[#a02c46]/40 transition flex items-center justify-center"
            >
              <X className="w-6 h-6 text-white" />
            </button>

            <div className="text-center mb-8">
              <CreditCard className="w-12 h-12 text-[#c94463] mx-auto mb-4" />
              <h2 className="text-4xl font-light">
                Payment{" "}
                <span className="font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
                  Plan
                </span>
              </h2>
              <p className="text-gray-400 mt-2">
                Flexible installment options for your dream apartment
              </p>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-[#a02c46]/30 to-[#c43a58]/30 rounded-xl">
                    <th className="p-4 text-left text-[#c94463]">Type</th>
                    <th className="p-4 text-left text-[#c94463]">
                      Size (sqft)
                    </th>
                    <th className="p-4 text-left text-[#c94463]">
                      Booking (PKR)
                    </th>
                    <th className="p-4 text-left text-[#c94463]">
                      Confirmation
                    </th>
                    <th className="p-4 text-left text-[#c94463]">Allocation</th>
                    <th className="p-4 text-left text-[#c94463]">
                      Total (PKR)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    ...paymentPlan.studio,
                    ...paymentPlan.oneBed,
                    ...paymentPlan.twoBed,
                    ...paymentPlan.threeBed,
                  ].map((item, index) => (
                    <tr
                      key={index}
                      className="border-t border-[#c94463]/20 hover:bg-[#a02c46]/10 transition"
                    >
                      <td className="p-4 font-medium">{item.type}</td>
                      <td className="p-4">{item.size}</td>
                      <td className="p-4">{item.booking.toLocaleString()}</td>
                      <td className="p-4">
                        {item.confirmation.toLocaleString()}
                      </td>
                      <td className="p-4">
                        {item.allocation.toLocaleString()}
                      </td>
                      <td className="p-4 font-semibold text-[#c94463]">
                        {item.total.toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="mt-10 flex justify-center">
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-4 bg-gradient-to-r from-[#a02c46] to-[#c43a58] hover:shadow-xl rounded-full transition-all duration-300 font-semibold hover:scale-105"
              >
                Book Your Unit on WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}

      {/* FOOTER */}
      <footer className="py-24 bg-gradient-to-b from-black/95 to-black border-t border-[#c94463]/30">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <div className="inline-flex items-center gap-2 bg-[#a02c46]/20 rounded-full px-4 py-2 mb-6">
            <Building2 className="w-4 h-4 text-[#c94463]" />
            <span className="text-sm tracking-wide text-[#c94463]">
              Floria Heights
            </span>
          </div>

          <h2 className="text-6xl font-light leading-tight mb-8">
            Let's Begin
            <span className="block font-bold bg-gradient-to-r from-[#c94463] to-[#e87a9c] bg-clip-text text-transparent">
              The Journey Home.
            </span>
          </h2>

          <p className="text-gray-300 leading-8 max-w-2xl mx-auto mb-10">
            Floria Heights is not just where you live. It's where your pace
            aligns with purpose.
          </p>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex px-8 py-4 bg-gradient-to-r from-[#a02c46] to-[#c43a58] rounded-full transition-all duration-300 font-semibold hover:shadow-lg hover:scale-105 gap-2 items-center"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.447-.521.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.01-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.298-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
            </svg>
            Contact on WhatsApp
          </a>

          <div className="border-t border-[#c94463]/30 mt-20 pt-10">
            <p className="text-gray-500">
              © Floria Heights — By Seven Ventures
            </p>
            <p className="text-[#c94463]/60 mt-2 text-sm tracking-wide">
              Inspired by Light. Elevated by Nature.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
